var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 6,
    viewBox: "0 0 14 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28243 0.205403C1.84359 -0.12991 1.21601 -0.0459809 0.880696 0.392863C0.545383 0.831707 0.629312 1.45928 1.06816 1.7946L2.28243 0.205403ZM6.91034 5L6.3032 5.7946C6.66163 6.06847 7.15904 6.06847 7.51747 5.7946L6.91034 5ZM12.7525 1.7946C13.1914 1.45928 13.2753 0.831707 12.94 0.392863C12.6047 -0.0459809 11.9771 -0.12991 11.5382 0.205403L12.7525 1.7946ZM1.06816 1.7946L6.3032 5.7946L7.51747 4.2054L2.28243 0.205403L1.06816 1.7946ZM7.51747 5.7946L12.7525 1.7946L11.5382 0.205403L6.3032 4.2054L7.51747 5.7946Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/dropDownIcon.016fa3c7857e892894ecbf59cd35b152.svg";
export { ForwardRef as ReactComponent };